import type { TZoneFlowRateByEmitterType } from '../../types'
import type { TSelectedZones } from '../ModalDrawerBulkEdit'

type TPropertyWithZones = {
  propertyId: number
  irrigationZones: TZoneFlowRateByEmitterType[]
}

export const getSelectableZones = (properties: TPropertyWithZones[]): TSelectedZones[] =>
  properties.flatMap(({ propertyId, irrigationZones }) =>
    irrigationZones.flatMap(({ zoneId, flowRate }) =>
      Object.values(flowRate).map(({ emitterType, id }) => ({ emitterType, id, zoneId, propertyId })),
    ),
  )
